module.exports = __webpack_public_path__ + "static/media/heart-of-san-francisco.164d1fae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/heart-of-san-francisco.jpg
// module id = 296
// module chunks = 0